export function EmptyState({ title, body }: { title: string; body: string }) {
  return (
    <div className="empty-state bevel-in" data-testid="empty-state">
      <p className="kicker">Empty</p>
      <h2>{title}</h2>
      <p className="muted">{body}</p>
    </div>
  );
}
